import {
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  TextField,
  Switch,
  FormControlLabel,
  Box,
} from "@mui/material";
import React, { useState } from "react";

import { connect } from "react-redux";
import { saveScholarshipAppealSettings } from "../../../../store/scholarship/actions";

const ScholarshipAppealSettingsDialog = (props) => {
  const {
    loading,
    showDialog,
    setShowDialog,
    saveScholarshipAppealSettings,
    scholarshipAppealSettings,
  } = props;

  const [formData, setFormData] = useState({
    enabled: !!scholarshipAppealSettings?.enabled,
    windowDays: scholarshipAppealSettings?.windowDays ?? 7,
  });

  const onSave = (e) => {
    e.preventDefault();
    saveScholarshipAppealSettings(
      {
        enabled: formData.enabled,
        windowDays: Number(formData.windowDays),
      },
      () => setShowDialog(false)
    );
  };

  return (
    <>
      <Dialog
        onClose={() => {
          setShowDialog(false);
        }}
        fullWidth
        maxWidth="xs"
        open={showDialog}
      >
        <DialogTitle>
          <Typography className="text-center text-uppercase text-primary">
            Scholarship Appeal Settings
          </Typography>
          <IconButton
            aria-label="close"
            onClick={() => {
              setShowDialog(false);
            }}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <span className="material-icons">close</span>
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <div className="row align-items-center mx-0 justify-content-center mt-3">
            <div className="col-11 mb-2">
              <FormControlLabel
                control={
                  <Switch
                    checked={formData.enabled}
                    onChange={(e) =>
                      setFormData({ ...formData, enabled: e.target.checked })
                    }
                    color="primary"
                  />
                }
                label={
                  <Box>
                    <Typography sx={{ fontWeight: 600 }}>
                      Enable appeals
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      Saving this on (re)opens the appeal window starting now,
                      for the number of days below.
                    </Typography>
                  </Box>
                }
                sx={{ alignItems: "flex-start" }}
              />
            </div>
            <div className="col-11 mb-2">
              <TextField
                label="Window (days)"
                type="number"
                size="small"
                fullWidth
                value={formData.windowDays}
                onChange={(e) =>
                  setFormData({ ...formData, windowDays: e.target.value })
                }
                inputProps={{ min: 1 }}
                helperText="Number of days appeals stay open once enabled"
              />
            </div>
          </div>
        </DialogContent>
        <DialogActions className="d-flex justify-content-center pb-4">
          <Button
            color="primary"
            variant="contained"
            onClick={onSave}
            type="button"
            disabled={loading || !formData.windowDays || formData.windowDays < 1}
            className="px-5"
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

const mapStateToProps = ({ loading }) => {
  return { loading };
};
export default connect(mapStateToProps, {
  saveScholarshipAppealSettings,
})(ScholarshipAppealSettingsDialog);
